import BaseError from './BaseError';

export default class UnknownError implements BaseError {
  readonly message = 'An unknown error occurred';
}
